// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__rgKOi","title":"styles_title__R6ZLg","gridContainer":"styles_gridContainer__DB0L2","divider":"styles_divider__kEUVN"};